import { z } from 'zod';

import { TSDMasterConsignmentInputMode, TSDType } from '@e-origin/shared';

// eslint-disable-next-line no-control-regex
const asciiRegex = /^[\x00-\x7F]*$/;

export const TSDCreateDataSchema = z
  .object({
    name: z
      .string()
      .min(1, { message: 'Required' })
      .regex(/^[a-zA-Z0-9-]*$/g, { message: 'Name is invalid' }),
    customer: z.string().min(1, { message: 'Required' }),
    template: z.string().optional(),
    type: z.nativeEnum(TSDType),
    file: z
      .instanceof(File, { message: 'File is required' })
      .refine((file) => asciiRegex.test(file.name), {
        message: 'File name contains invalid characters.',
      })
      .nullable()
      .optional(),
    masterConsignmentInputMode: z.nativeEnum(TSDMasterConsignmentInputMode).optional(),
    generalInfo: z
      .object({
        declarationDate: z.union([z.date(), z.string()]).optional(),
        ensReUseIndicator: z.boolean().optional(),
        dateAndTimeOfPresentationOfTheGoods: z.union([z.date(), z.string()]).optional(),
      })
      .optional(),
    messageInfo: z
      .object({
        LRN: z.string().optional(),
        MRN: z.string().optional(),
      })
      .optional(),
    consignment: z
      .object({
        master: z
          .object({
            totalNumberOfPackages: z.string().optional(),
            totalGrossMass: z.string().optional(),
            transportDocuments: z
              .array(
                z.object({
                  type: z.string().optional(),
                  referenceNumber: z.string().optional(),
                }),
              )
              .optional(),
          })
          .optional(),
      })
      .optional(),
    locationOfGoodsUNLocode: z.string().min(1, { message: 'Required' }).nullable(),
    warehouse: z.string().min(1, { message: 'Required' }).nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.type === TSDType.TRANSFERRED) {
      if (!data.messageInfo?.LRN || data.messageInfo.LRN.trim() === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required',
          path: ['messageInfo', 'LRN'],
        });
      }
      if (!data.messageInfo?.MRN || data.messageInfo.MRN.trim() === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required',
          path: ['messageInfo', 'MRN'],
        });
      }
    }
  });
export type TSDCreateData = z.infer<typeof TSDCreateDataSchema>;
